import { Container, Flex, Icon } from "@chakra-ui/react";
import { Breadcrumb, PreviousButton } from "components";
import { Heading } from "elements";
import { useState } from "react";
import { routes } from "utils";
import { BookDetailsTile } from "./BookDetailsTile";
import { RiVisaLine } from 'react-icons/ri';
import { SiMastercard, SiPaypal } from 'react-icons/si';
import { CheckboxCard } from "components/CheckboxCard";
import { BookingStepsLabels, PaymentMethodOptions, PaymentMethodOptionsEnum } from "utils/enums";


const PaymentMethod = () => {
  const [paymentMethod, setPaymentMethod] = useState<PaymentMethodOptions>({
    card: false,
    paypal: false,
  });

  const onHowToPayChange = (label: keyof PaymentMethodOptions, value: boolean) => {
    let data = {
      card: false,
      paypal: false,
    };
    data[label] = value;
    setPaymentMethod(data);
  };

  return (
    <>
      <PreviousButton />
      <Container marginTop={5} marginLeft={0} marginBottom={5} paddingLeft={0}>
        <Heading title="Payment" color="#1F1E1E" fontWeight={700} />
      </Container>
      <Breadcrumb color="#1F1E1E" linkList={[
        { link: routes.BOOKING.HOW_TO_PAY, title: BookingStepsLabels.STEP_1 },
        { link: '', title: BookingStepsLabels.STEP_2 }]} />
      <Container marginTop={50} marginLeft={0} marginBottom={5} paddingLeft={0}>
        <Heading fontSize="32px" title="2. Choose payment method" color="#3498FE" fontWeight={700} />
      </Container>
      <Flex flexDirection={['column', 'column', 'column', 'row']} justifyContent='space-between' gap={[10]}>
        <Flex flexDirection='column' width={['100%']}>
          <CheckboxCard
            title='Credit Card / Debit Card'
            icons={<>   <Icon as={SiMastercard} w={8} h={8} marginLeft={10} />
              <Icon as={RiVisaLine} w={8} h={8} marginLeft={5} /></>}
            isChecked={paymentMethod.card}
            label={PaymentMethodOptionsEnum.CARD}
            onChange={onHowToPayChange}
          />
          <CheckboxCard
            title='Paypal'
            icons={<Icon as={SiPaypal} w={8} h={8} marginLeft={10} />}
            isChecked={paymentMethod.paypal}
            label={PaymentMethodOptionsEnum.PAYPAL}
            onChange={onHowToPayChange}
          />
        </Flex>
        <BookDetailsTile price={300} nights={5}
          type="Stays" title="Bucharest" numberOfReviews={20} rating={5} url={routes.BOOKING.DETAILS} image="https://i.postimg.cc/pd2xmCxz/destination-img-1.jpg" housekeepingFee={0} platformFee={0} parkingFee={5} />
      </Flex>
    </>
  );
};

export { PaymentMethod };
